import { useWidgetThemeParams } from "./useWidgetThemeParams";

/**
 * Hook to check if edit mode is enabled via URL parameter or localStorage
 * Usage: Add ?editMode=true to the URL or save to localStorage to enable edit mode
 */
export const useEditMode = (): boolean => {
  const themeParams = useWidgetThemeParams();
  return themeParams.editMode;
};
